import { Link } from 'react-router-dom';
import { ArrowRight, Check, Clock, Users, Award, BarChart } from 'lucide-react';
import { Button } from "@/components/ui/button";

export function CTASection() {
  return (
    <div className="bg-gradient-to-r from-primary to-blue-700 relative overflow-hidden">
      <div aria-hidden="true" className="absolute inset-0 -z-10">
           <svg className="absolute bottom-0 left-1/2 -translate-x-1/2" width={1000} height={800} fill="none" viewBox="0 0 1000 800">
             <circle cx={500} cy={500} r={500} fill="url(#cta-gradient)" />
             <defs>
               <radialGradient id="cta-gradient" cx={0} cy={0} r={1} gradientUnits="userSpaceOnUse" gradientTransform="translate(500 500) rotate(90) scale(500)">
                 <stop stopColor="rgba(255, 255, 255, 0.1)" />
                 <stop offset={1} stopColor="rgba(var(--primary-rgb), 0.3)" stopOpacity={0} />
               </radialGradient>
             </defs>
           </svg>
       </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 sm:py-28 lg:px-8">
        <div className="text-center mb-10">
          <span className="inline-flex items-center rounded-full bg-primary-foreground/20 px-4 py-1 text-sm font-medium text-primary-foreground mb-5">
            <Clock className="mr-1.5 h-4 w-4" />
            Limited Time Offer: Get 25% off your first 3 months
          </span>
        
          <h2 className="text-3xl font-extrabold tracking-tight text-primary-foreground sm:text-4xl lg:text-5xl">
            Transform Your Hiring Process Today
          </h2>
          <p className="mt-4 text-lg leading-7 text-primary-foreground/90 max-w-2xl mx-auto">
            Don't miss out on the perfect candidates while using outdated hiring methods. Join 500+ companies making smarter, faster hiring decisions.
          </p>
        </div>

        {/* Stats for social proof */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-12 text-center">
          <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-4">
            <div className="flex justify-center mb-2">
              <Award className="h-6 w-6 text-primary-foreground/80" />
            </div>
            <p className="text-2xl font-bold text-primary-foreground">70%</p>
            <p className="text-sm text-primary-foreground/80">Faster Time-to-Hire</p>
          </div>
          <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-4">
            <div className="flex justify-center mb-2">
              <BarChart className="h-6 w-6 text-primary-foreground/80" />
            </div>
            <p className="text-2xl font-bold text-primary-foreground">4x</p>
            <p className="text-sm text-primary-foreground/80">Higher Productivity</p>
          </div>
          <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-4">
            <div className="flex justify-center mb-2">
              <Users className="h-6 w-6 text-primary-foreground/80" />
            </div>
            <p className="text-2xl font-bold text-primary-foreground">45%</p>
            <p className="text-sm text-primary-foreground/80">Reduced Turnover</p>
          </div>
          <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-4">
            <div className="flex justify-center mb-2">
              <Clock className="h-6 w-6 text-primary-foreground/80" />
            </div>
            <p className="text-2xl font-bold text-primary-foreground">82%</p>
            <p className="text-sm text-primary-foreground/80">Better Candidates</p>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center gap-y-4 sm:flex-row sm:gap-x-4">
          <Button asChild size="lg" className="group bg-primary-foreground text-primary hover:bg-primary-foreground/90 shadow-lg hover:shadow-xl transition-all duration-300 w-full sm:w-auto text-base">
            <Link to="/signup">
              Start Your Free Trial
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
          <Button variant="outline" size="lg" asChild className="border-primary-foreground/50 text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground w-full sm:w-auto text-base">
            <Link to="/pricing">
              View Plans & Pricing
            </Link>
          </Button>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-3 max-w-2xl mx-auto">
          <div className="flex items-center text-primary-foreground/90 text-sm">
            <Check className="h-4 w-4 mr-2 flex-shrink-0" /> 4 free matches
          </div>
          <div className="flex items-center text-primary-foreground/90 text-sm">
            <Check className="h-4 w-4 mr-2 flex-shrink-0" /> No credit card required
          </div>
          <div className="flex items-center text-primary-foreground/90 text-sm">
            <Check className="h-4 w-4 mr-2 flex-shrink-0" /> Cancel anytime
          </div>
          <div className="flex items-center text-primary-foreground/90 text-sm">
            <Check className="h-4 w-4 mr-2 flex-shrink-0" /> Custom interview plans
          </div>
          <div className="flex items-center text-primary-foreground/90 text-sm">
            <Check className="h-4 w-4 mr-2 flex-shrink-0" /> Smart talent matching
          </div>
          <div className="flex items-center text-primary-foreground/90 text-sm">
            <Check className="h-4 w-4 mr-2 flex-shrink-0" /> 24/7 support
          </div>
        </div>

        <div className="mt-6 flex justify-center">
          <span className="px-3 py-1 bg-primary-foreground/20 text-primary-foreground text-xs rounded-full animate-pulse">
            Only 7 free trial spots left today
          </span>
        </div>
      </div>
    </div>
  );
}